module.exports = __webpack_public_path__ + "img/Mask Group2.4248d1b3.png";